<template>
  <div class="audience-page">
    <Header :title="showLang[selectLang]['views']['AudienceCenter']['page_name']" @childLang="useLang" @toggleSidebar="$emit('toggleSidebar')">
      <div class="aud-toolbar-label">
        {{showLang[selectLang]['views']['AudienceCenter']['advertising_source']}}
      </div>
      <div class="aud-toolbar-dropdown">
        <Dropdown
          v-model="fromAccountSelect"
          optionLabel="name"
          optionValue="code"
          :options="fromAccountOptions"
          :placeholder="showLang[selectLang]['views']['AudienceCenter']['advertise_account_placeholder_text']"
          appendTo="body"
          class="w-36 ml-2s rounded-md"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
        >
          <template #value="slotProps">
            <div v-if="slotProps.value" class="flex align-items-center">
              <img v-if="slotProps.value == 'facebook'" :alt="slotProps.value" width="28" src="https://test-private.autoturn.net/img/facebook_icon.png"/>
              <img v-if="slotProps.value == 'tiktok'" class="mt-0.5 mr-0.5 mb-0.5" :alt="slotProps.value" width="25" src="https://test-private.autoturn.net/img/tiktok_icon.png"/>
              <div v-if="slotProps.value == 'facebook'" class="leading-7">Facebook</div>
              <div v-if="slotProps.value == 'tiktok'" class="leading-7">Tiktok</div>
            </div>
            <span v-else>
                {{ slotProps.placeholder }}
            </span>
          </template>
          <template #option="slotProps">
            <div class="flex align-items-center">
              <img v-if="slotProps.option.code == 'facebook'" class="-ml-0.5" :alt="slotProps.option.name" width="28" src="https://test-private.autoturn.net/img/facebook_icon.png"/>
              <img v-if="slotProps.option.code == 'tiktok'" class="mt-0.5 mr-0.5 mb-0.5" :alt="slotProps.option.name" width="25" src="https://test-private.autoturn.net/img/tiktok_icon.png"/>
              <div class="leading-7">{{ slotProps.option.name }}</div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div class="aud-toolbar-label">
        {{showLang[selectLang]['views']['AudienceCenter']['advertise_account_text']}}
      </div>
      <div class="aud-toolbar-dropdown">
        <Dropdown
          v-model="accountSelect"
          optionLabel="name"
          optionValue="code"
          :options="accountOptions"
          :placeholder="showLang[selectLang]['views']['AudienceCenter']['advertise_account_placeholder_text']"
          appendTo="body"
          class="w-52 ml-2s rounded-md leading-8"
          :style="[fromAccountSelect == 'facebook' ? 'border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);' : 'border: 2px solid rgb(32, 3, 24); color: rgb(32, 3, 24);']"
          filter
          @change="adaccount(accountSelect)"
        />
      </div>
      <div v-if="isPlan142 && quotaLoaded" class="aud-quota">
        <i class="fas fa-database aud-quota-icon"></i>
        <span class="aud-quota-label">本月受眾額度：</span>
        <span class="aud-quota-value"
          :class="audienceQuota.remaining <= 10000 ? 'aud-quota-value--danger' : 'aud-quota-value--ok'">
          {{ audienceQuota.remaining.toLocaleString() }}
        </span>
        <span class="aud-quota-total">/ {{ audienceQuota.monthlyLimit.toLocaleString() }}</span>
      </div>
    </Header>
    <main class="audience-main">
      <div class="audience-content">
        <!-- 標籤/分類 切換按鈕 -->
        <div class="mode-tabs">
          <button
            @click="audienceMode = 'tag'"
            class="mode-tab"
            :class="{ active: audienceMode === 'tag' }"
          >
            <i class="fas fa-tags"></i>標籤
          </button>
          <button
            @click="audienceMode = 'category'"
            class="mode-tab"
            :class="{ active: audienceMode === 'category' }"
          >
            <i class="fas fa-th-large"></i>分類
          </button>
        </div>

        <!-- 消費統計查詢 -->
        <div class="aud-card">
          <h3 class="aud-card-title">
            <i class="fas fa-chart-bar"></i>消費統計查詢
          </h3>

          <!-- 標籤模式：單選搜尋 -->
          <div v-if="audienceMode === 'tag'">
            <div class="two-col">
              <div class="stats-tag-search-area">
                <label class="col-label">搜尋標籤</label>
                <div class="search-wrap">
                  <i class="fas fa-search search-icon"></i>
                  <input
                    type="text"
                    v-model="statsTagSearchQuery"
                    @input="onStatsTagSearch"
                    @focus="showStatsTagDropdown = true"
                    placeholder="輸入關鍵字搜尋標籤..."
                    class="search-input"
                  />
                </div>
                <!-- 搜尋結果下拉 -->
                <div
                  v-if="showStatsTagDropdown && statsTagSearchQuery.length > 0 && statsFilteredTags.length > 0"
                  class="autocomplete"
                >
                  <div
                    v-for="(tag, index) in statsFilteredTags"
                    :key="index"
                    @click="selectStatsTag(tag)"
                    class="autocomplete-item"
                    :class="{ active: statsSelectedTag === tag }"
                  >
                    <div class="autocomplete-check" :class="{ checked: statsSelectedTag === tag }"><i class="fas fa-check"></i></div>
                    <span class="autocomplete-tag-name">{{ tag }}</span>
                  </div>
                </div>
                <!-- 無結果提示 -->
                <div
                  v-if="showStatsTagDropdown && statsTagSearchQuery.length > 0 && statsFilteredTags.length === 0"
                  class="autocomplete"
                >
                  <div class="autocomplete-empty">找不到符合的標籤</div>
                </div>
              </div>
              <!-- 已選標籤 -->
              <div>
                <label class="col-label">已選擇的標籤</label>
                <div class="selected-area" :class="{ 'selected-area--centered': !statsSelectedTag }">
                  <div v-if="!statsSelectedTag" class="selected-empty">尚未選擇標籤</div>
                  <span
                    v-else
                    class="tag-pill"
                  >
                    {{ statsSelectedTag }}
                    <button @click="clearStatsTag" class="tag-pill-x">
                      <i class="fas fa-times"></i>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- 分類模式：主分類 + 次分類 -->
          <div v-if="audienceMode === 'category'" class="two-col">
            <div>
              <label class="col-label">主分類</label>
              <Dropdown
                v-model="statsSelectedMainCategory"
                optionLabel="ProductTypeName"
                optionValue="main_type"
                :options="allCategories"
                placeholder="請選擇主分類"
                class="w-full rounded-md"
                style="border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);"
                filter
                @change="onStatsMainCategoryChange"
              />
            </div>
            <div>
              <label class="col-label">次分類</label>
              <Dropdown
                v-model="statsSelectedSubCategory"
                optionLabel="ProductSubTypeName"
                optionValue="sub_type"
                :options="statsSubCategoryOptions"
                placeholder="請先選擇主分類"
                class="w-full rounded-md"
                style="border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);"
                :disabled="!statsSelectedMainCategory"
                filter
                @change="onStatsSubCategoryChange"
              />
            </div>
          </div>

          <!-- 統計結果 -->
          <div v-if="statsLoading" class="aud-loading">
            <i class="fas fa-spinner fa-spin"></i>查詢中...
          </div>
          <div v-if="statsLoaded && !statsLoading" class="stat-row">
            <!-- 消費頻率 -->
            <div class="stat-card">
              <div class="stat-icon blue"><i class="fas fa-redo"></i></div>
              <div>
                <div class="stat-label">消費頻率</div>
                <div class="stat-value">{{ statsDisplay.avgCount }}</div>
              </div>
            </div>
            <!-- 人均消費 -->
            <div class="stat-card">
              <div class="stat-icon green"><span class="stat-icon-dollar">$</span></div>
              <div>
                <div class="stat-label">人均消費</div>
                <div class="stat-value">{{ statsDisplay.avgTotalAmount.toLocaleString() }}</div>
              </div>
            </div>
            <!-- 總消費人次 -->
            <div class="stat-card">
              <div class="stat-icon purple"><i class="fas fa-users"></i></div>
              <div>
                <div class="stat-label">總消費人次</div>
                <div class="stat-value">{{ statsDisplay.memberCount.toLocaleString() }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 標籤模式 -->
        <div v-if="audienceMode === 'tag'" class="aud-card">
          <h3 class="aud-card-title"><i class="fas fa-user-plus"></i>依標籤建立受眾<i class="fas fa-info-circle aud-help-icon" v-tooltip.top="'若要建立精準受眾，請確認目前您的帳號為Meta企業管理平台帳號。'"></i></h3>

          <div class="two-col">
            <!-- 左側：搜尋標籤 -->
            <div class="tag-search-area">
              <label class="col-label"><i class="fas fa-search"></i>搜尋標籤</label>
              <div class="search-wrap">
                <i class="fas fa-search search-icon"></i>
                <input
                  type="text"
                  v-model="tagSearchQuery"
                  @input="onTagSearch"
                  @focus="showTagDropdown = true"
                  placeholder="輸入關鍵字搜尋標籤..."
                  class="search-input"
                />
              </div>
              <!-- 搜尋結果下拉 -->
              <div
                v-if="showTagDropdown && tagSearchQuery.length > 0 && filteredTags.length > 0"
                class="autocomplete"
              >
                <div
                  v-for="(tag, index) in filteredTags"
                  :key="index"
                  @click="selectTag(tag)"
                  class="autocomplete-item"
                  :class="{ active: selectedTags.includes(tag) }"
                >
                  <div class="autocomplete-check" :class="{ checked: selectedTags.includes(tag) }"><i class="fas fa-check"></i></div>
                  <span class="autocomplete-tag-name">{{ tag }}</span>
                </div>
              </div>
              <!-- 無結果提示 -->
              <div
                v-if="showTagDropdown && tagSearchQuery.length > 0 && filteredTags.length === 0"
                class="autocomplete"
              >
                <div class="autocomplete-empty">找不到符合的標籤</div>
              </div>
            </div>

            <!-- 右側：已選標籤 -->
            <div>
              <label class="col-label">
                <i class="fas fa-check-circle"></i>已選擇的標籤
                <span v-if="selectedTags.length > 0" class="col-label-count">({{ selectedTags.length }})</span>
              </label>
              <div
                class="selected-area"
                :class="{ 'selected-area--centered': selectedTags.length === 0 }"
              >
                <div v-if="selectedTags.length === 0" class="selected-empty">尚未選擇任何標籤</div>
                <div v-else>
                  <div class="selected-header">
                    <span class="selected-count">已選 {{ selectedTags.length }} 個標籤</span>
                    <a @click="clearAllTags" class="clear-all"><i class="fas fa-trash"></i> 清除全部</a>
                  </div>
                  <div class="selected-tags">
                    <span
                      v-for="(tag, index) in selectedTags"
                      :key="index"
                      class="tag-pill"
                    >
                      {{ tag }}
                      <button
                        @click="removeTag(index)"
                        class="tag-pill-x"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 查詢受眾按鈕 + 結果 -->
          <div class="query-row">
            <button
              @click="queryAudienceCount"
              :disabled="selectedTags.length === 0 || audienceQuerying"
              class="btn btn-outline btn-sm"
            >
              <i v-if="audienceQuerying" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fas fa-search"></i>
              {{ audienceQuerying ? '查詢中...' : '查詢受眾筆數' }}
            </button>
            <div v-if="audienceQueried" class="result-display">
              <span>受眾筆數：</span>
              <span class="result-value" :class="audienceSize > 50000 ? 'orange' : 'green'">{{ audienceSize.toLocaleString() }}</span>
            </div>
          </div>
          <!-- 超過 50000 警告 -->
          <div v-if="audienceQueried && audienceSize > 50000" class="warning-box">
            <i class="fas fa-exclamation-triangle"></i>
            <span>受眾筆數超過 50,000 筆，建立受眾時僅會上傳前 50,000 筆資料。</span>
          </div>
          <!-- 額度不足警告 -->
          <div v-if="isPlan142 && audienceQueried && isQuotaInsufficient" class="warning-box warning-box--danger">
            <i class="fas fa-ban"></i>
            <span>
              受眾額度不足！本次需要 {{ effectiveAudienceCount.toLocaleString() }} 筆，剩餘僅 {{ audienceQuota.remaining.toLocaleString() }} 筆。
            </span>
          </div>

          <!-- 受眾名稱 + 建立按鈕 -->
          <div class="aud-create-section">
            <div class="aud-create-row">
              <div class="aud-create-input-wrap">
                <label class="col-label">受眾名稱</label>
                <input
                  type="text"
                  v-model="audienceName"
                  placeholder="請輸入受眾名稱"
                  class="name-input"
                />
              </div>
              <button
                @click="createAudience"
                :disabled="audienceName.trim() === '' || selectedTags.length === 0 || audienceCreating || isQuotaInsufficient"
                class="btn btn-primary"
              >
                <i v-if="audienceCreating" class="fas fa-spinner fa-spin"></i>
                <i v-else class="fas fa-plus"></i>
                {{ audienceCreating ? '建立中...' : '建立受眾' }}
              </button>
            </div>
          </div>
        </div>

        <!-- 分類模式 -->
        <div v-if="audienceMode === 'category'" class="aud-card">
          <h3 class="aud-card-title"><i class="fas fa-user-plus"></i>依分類建立受眾<i class="fas fa-info-circle aud-help-icon" v-tooltip.top="'若要建立精準受眾，請確認目前您的帳號為Meta企業管理平台帳號。'"></i></h3>

          <div class="two-col">
            <!-- 主分類 -->
            <div>
              <label class="col-label">主分類</label>
              <Dropdown
                v-model="selectedMainCategory"
                optionLabel="ProductTypeName"
                optionValue="main_type"
                :options="allCategories"
                placeholder="請選擇主分類"
                class="w-full rounded-md"
                style="border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);"
                filter
                @change="onMainCategoryChange"
              />
            </div>

            <!-- 次分類 -->
            <div>
              <label class="col-label">次分類</label>
              <Dropdown
                v-model="selectedSubCategory"
                optionLabel="ProductSubTypeName"
                optionValue="sub_type"
                :options="subCategoryOptions"
                placeholder="請先選擇主分類"
                class="w-full rounded-md"
                style="border: 2px solid rgb(53, 102, 165); color: rgb(53, 102, 165);"
                :disabled="!selectedMainCategory"
                filter
              />
            </div>
          </div>

          <!-- 查詢受眾按鈕 + 結果 -->
          <div class="query-row">
            <button
              @click="queryAudienceCount"
              :disabled="!selectedSubCategory || audienceQuerying"
              class="btn btn-outline btn-sm"
            >
              <i v-if="audienceQuerying" class="fas fa-spinner fa-spin"></i>
              <i v-else class="fas fa-search"></i>
              {{ audienceQuerying ? '查詢中...' : '查詢受眾筆數' }}
            </button>
            <div v-if="audienceQueried" class="result-display">
              <span>受眾筆數：</span>
              <span class="result-value" :class="audienceSize > 50000 ? 'orange' : 'green'">{{ audienceSize.toLocaleString() }}</span>
            </div>
          </div>
          <!-- 超過 50000 警告 -->
          <div v-if="audienceQueried && audienceSize > 50000" class="warning-box">
            <i class="fas fa-exclamation-triangle"></i>
            <span>受眾筆數超過 50,000 筆，建立受眾時僅會上傳前 50,000 筆資料。</span>
          </div>
          <!-- 額度不足警告 -->
          <div v-if="isPlan142 && audienceQueried && isQuotaInsufficient" class="warning-box warning-box--danger">
            <i class="fas fa-ban"></i>
            <span>
              受眾額度不足！本次需要 {{ effectiveAudienceCount.toLocaleString() }} 筆，剩餘僅 {{ audienceQuota.remaining.toLocaleString() }} 筆。
            </span>
          </div>

          <!-- 受眾名稱 + 建立按鈕 -->
          <div class="aud-create-section">
            <div class="aud-create-row">
              <div class="aud-create-input-wrap">
                <label class="col-label">受眾名稱</label>
                <input
                  type="text"
                  v-model="audienceName"
                  placeholder="請輸入受眾名稱"
                  class="name-input"
                />
              </div>
              <button
                @click="createAudience"
                :disabled="audienceName.trim() === '' || !selectedSubCategory || audienceCreating || isQuotaInsufficient"
                class="btn btn-primary"
              >
                <i v-if="audienceCreating" class="fas fa-spinner fa-spin"></i>
                <i v-else class="fas fa-plus"></i>
                {{ audienceCreating ? '建立中...' : '建立受眾' }}
              </button>
            </div>
          </div>
        </div>

      </div>
    </main>
  </div>
</template>

<script>

import Dropdown from 'primevue/dropdown'
import Header from '@/components/Header.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import axios from 'axios'
import Qs from 'qs'
import lang from '@/language/lang.json'
import tiktokLang from '@/language/tiktok_lang.json'

export default {
  name: 'AudienceCenter',
  components: {
    Header,
    Dropdown,
  },
  data() {
    return {
      selectLang: 'zh-TW',
      showLang: lang,
      showTiktokLang: tiktokLang,
      fromAccountSelect: 'facebook',
      fromAccountOptions: [{"name":"Facebook","code":"facebook"},{"name":"Tiktok","code":"tiktok"}],
      dataType: 'facebook',
      accountSelect: '',
      accountOptions: [],
      // 標籤/分類
      audienceMode: 'tag',
      allTags: [],
      filteredTags: [],
      selectedTags: [],
      tagSearchQuery: '',
      showTagDropdown: false,
      // 分類
      allCategories: [],
      subCategoryOptions: [],
      selectedMainCategory: null,
      selectedSubCategory: null,
      // 受眾查詢
      audienceSize: 0,
      audienceQuerying: false,
      audienceQueried: false,
      // 建立受眾
      audienceName: '',
      audienceCreating: false,
      memberId: null,
      // 消費統計查詢
      statsTagSearchQuery: '',
      statsFilteredTags: [],
      statsSelectedTag: null,
      showStatsTagDropdown: false,
      statsSelectedMainCategory: null,
      statsSelectedSubCategory: null,
      statsSubCategoryOptions: [],
      statsData: { avgCount: null, avgTotalAmount: null, memberCount: null },
      statsDisplay: { avgCount: 0, avgTotalAmount: 0, memberCount: 0 },
      statsLoading: false,
      statsLoaded: false,
      // 受眾配額 (Plan 142)
      isPlan142: false,
      audienceQuota: { monthlyLimit: 100000, totalUsed: 0, remaining: 100000 },
      quotaLoaded: false,
    }
  },
  computed: {
    effectiveAudienceCount(){
      return Math.min(this.audienceSize, 50000);
    },
    isQuotaInsufficient(){
      if(!this.isPlan142 || !this.audienceQueried) return false;
      return this.effectiveAudienceCount > this.audienceQuota.remaining;
    },
  },
  created() {
    let hash = this.$route.params.id;
    let routeType = this.$route.params.type;
    let campaignAdaccountsUrl = 'https://www.autoturn.net/api/campaign_adaccounts.php';

    if(routeType != '' && routeType != null && typeof routeType != 'undefined'){
      if(routeType == 't'){
        this.fromAccountSelect = 'tiktok';
        this.dataType = 'tiktok';
        campaignAdaccountsUrl = 'https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_adaccounts.php';
      }
    }

    if(hash != '' && hash != null && typeof hash != 'undefined'){

      let member_hash = this.$route.params.id

      axios
        .post('https://www.autoturn.net/api/campaign_member_status.php', Qs.stringify({
          s_code: member_hash,
          route_type: this.$route.params.type,
          active: 'audience_center',
        }))
        .then((caResponse) => {

          if(caResponse.data.status == 'error'){
            if(caResponse.data.type == 2){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['error']['confirm_button']
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.href = "https://test-private.autoturn.net/audience-center/"+routeType+"/"+member_hash;
                } else if (result.isDenied) {
                  window.location.href = "https://test-private.autoturn.net/audience-center/"+routeType+"/"+member_hash;
                }
              })
            } else if(caResponse.data.type == 3){
              Swal.fire({
                icon: caResponse.data.status,
                title: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['error']['swal_title'],
                text: caResponse.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['error']['confirm_button']
              }).then((result) => {
                if (result.isConfirmed) {
                  window.location.href = "https://test-private.autoturn.net/"+routeType+"/"+member_hash;
                } else if (result.isDenied) {
                  window.location.href = "https://test-private.autoturn.net/"+routeType+"/"+member_hash;
                }
              })
            } else {
              Swal.fire(
                this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['error']['swal_title'],
                caResponse.data.info,
                caResponse.data.status
              )
            }
          }

          if(caResponse.data.status == 'warning'){
            Swal.fire({
              icon: 'warning',
              title: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['warning']['swal_title'],
              text: caResponse.data.info,
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['warning']['confirm_button']
            }).then((result) => {
              if (result.isConfirmed) {
                axios
                  .post(campaignAdaccountsUrl, Qs.stringify({
                    s_code: this.$route.params.id,
                    adaccount_id: this.$route.params.adaccount_id,
                    type: 'audience_center',
                  }))
                  .then((adResponse) => {
                    if(adResponse.data.status == 'success'){
                      if(adResponse.data.return_data.length > 0){
                        this.accountOptions = adResponse.data.return_data
                        this.accountSelect = adResponse.data.selecded_data
                      } else {
                        Swal.fire({
                          icon: 'error',
                          title: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['warning']['data_empty_title'],
                          text: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['warning']['data_empty_text'],
                          showDenyButton: false,
                          showCancelButton: false,
                          confirmButtonText: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['warning']['data_empty_confirm_button']
                        }).then((result) => {
                          if (result.isConfirmed) {
                            window.location.href = "https://test-private.autoturn.net/"+routeType+"/"+hash;
                          } else if (result.isDenied) {
                            window.location.href = "https://test-private.autoturn.net/"+routeType+"/"+hash;
                          }
                        })
                      }
                    }
                  });
              }
            });
          }

          if(caResponse.data.status == 'success'){
            axios
              .post(campaignAdaccountsUrl, Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                type: 'audience_center',
              }))
              .then((adResponse) => {
                if(adResponse.data.status == 'success'){
                  if(adResponse.data.return_data.length > 0){
                    this.accountOptions = adResponse.data.return_data
                    this.accountSelect = adResponse.data.selecded_data
                  } else {
                    Swal.fire({
                      icon: 'error',
                      title: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['success']['data_empty_title'],
                      text: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['success']['data_empty_text'],
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['success']['data_empty_confirm_button']
                    }).then((result) => {
                      if (result.isConfirmed) {
                        window.location.href = "https://test-private.autoturn.net/"+routeType+"/"+hash;
                      } else if (result.isDenied) {
                        window.location.href = "https://test-private.autoturn.net/"+routeType+"/"+hash;
                      }
                    })
                  }
                }
              });
          }

          if(caResponse.data.status == 'login'){
            Swal.fire({
              icon: 'error',
              title: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['login']['swal_title'],
              text: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['login']['swal_text'],
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['axios']['campaign_member_status']['login']['confirm_button']
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
              } else if (result.isDenied) {
                window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
              }
            })
          }
        });
    } else {
      Swal.fire({
        icon: 'error',
        title: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['no_hash_swal_title'],
        text: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['no_hash_swal_text'],
        showDenyButton: false,
        showCancelButton: false,
        confirmButtonText: this.showLang[this.selectLang]['views']['AudienceCenter']['created']['no_hash_confirm_button']
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
        } else if (result.isDenied) {
          window.location.href = "https://test.autoturn.net/inside/index.php/index/logout?o=1";
        }
      })
    }
  },
  watch:{
    fromAccountSelect(v){
      console.log('AudienceCenter fromAccountSelect');
      console.log(v);

      this.dataType = v

      let routeType = 'f';
      let campaignAdaccountsUrl = 'https://www.autoturn.net/api/campaign_adaccounts.php';

      if(v == 'tiktok'){
        routeType = 't';
        campaignAdaccountsUrl = 'https://www.autoturn.net/api/tiktok/campaign/tiktok_campaign_adaccounts.php';
      }

      this.$router.push({ params: { type: routeType }});

      axios
        .post(campaignAdaccountsUrl, Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: this.$route.params.adaccount_id,
          type: 'audience_center',
        }))
        .then((adResponse) => {
          if(adResponse.data.status == 'success'){
            if(adResponse.data.return_data.length > 0){
              this.accountOptions = adResponse.data.return_data
              this.accountSelect = adResponse.data.selecded_data
            } else {
              this.accountOptions = []
              this.accountSelect = ''
            }
          }
        });
    }
  },
  mounted() {
    // 載入所有標籤
    this.loadTags();
    // 載入所有分類
    this.loadCategories();
    // 取得 member_id
    this.fetchMemberId();
    // 取得受眾配額 (Plan 142)
    this.fetchAudienceQuota();

    // 點擊外部關閉下拉選單
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    useLang(v){
      this.selectLang = v;
      this.$emit('childLang', v);
    },
    adaccount(v){
      console.log('AudienceCenter adaccount change');
      console.log(v);
    },
    fetchMemberId(){
      axios
        .post('https://www.autoturn.net/api/login.php', Qs.stringify({
          s_code: this.$route.params.id,
          type: this.$route.params.type
        }), {withCredentials: true})
        .then((response) => {
          if(response.data.status === 'success'){
            this.memberId = response.data.id;
            console.log('Member ID loaded:', this.memberId);
          }
        })
        .catch((error) => {
          console.error('Failed to fetch member ID:', error);
        });
    },
    fetchAudienceQuota(){
      axios
        .post('https://www.autoturn.net/api/audience_quota_check.php', Qs.stringify({
          s_code: this.$route.params.id
        }))
        .then((response) => {
          if(response.data.status === 'success'){
            if(response.data.data.is_plan_142){
              this.isPlan142 = true;
              this.audienceQuota.monthlyLimit = response.data.data.monthly_limit;
              this.audienceQuota.totalUsed = response.data.data.total_used;
              this.audienceQuota.remaining = response.data.data.remaining;
            }
            this.quotaLoaded = true;
          }
        })
        .catch((error) => {
          console.error('Failed to fetch audience quota:', error);
          this.quotaLoaded = true;
        });
    },
    recordAudienceUsage(){
      axios
        .post('https://www.autoturn.net/api/audience_usage_record.php', Qs.stringify({
          s_code: this.$route.params.id,
          audience_size: this.audienceSize,
          audience_name: this.audienceName.trim()
        }))
        .then((response) => {
          if(response.data.status === 'success'){
            this.audienceQuota.remaining = response.data.data.remaining;
            this.audienceQuota.totalUsed = this.audienceQuota.monthlyLimit - response.data.data.remaining;
          }
        })
        .catch((error) => {
          console.error('Failed to record audience usage:', error);
        });
    },
    loadTags(){
      axios
        .get('https://dashbk.ecpaydata.com.tw/api/api.php?act=query_all_tags')
        .then((response) => {
          if(response.data && response.data.data){
            this.allTags = response.data.data.map(item => item.tag);
            console.log('Tags loaded:', this.allTags.length);
          }
        })
        .catch((error) => {
          console.error('Failed to load tags:', error);
        });
    },
    onTagSearch(){
      if(this.tagSearchQuery.length === 0){
        this.filteredTags = [];
        return;
      }
      const query = this.tagSearchQuery.toLowerCase();
      this.filteredTags = this.allTags.filter(tag =>
        tag.toLowerCase().includes(query)
      ).slice(0, 50);
      this.showTagDropdown = true;
    },
    selectTag(tag){
      if(!this.selectedTags.includes(tag)){
        if(this.selectedTags.length >= 15){
          Swal.fire('提示', '最多只能選擇 15 個標籤', 'warning');
          return;
        }
        this.selectedTags.push(tag);
      } else {
        const idx = this.selectedTags.indexOf(tag);
        this.selectedTags.splice(idx, 1);
      }
    },
    removeTag(index){
      this.selectedTags.splice(index, 1);
    },
    clearAllTags(){
      this.selectedTags = [];
    },
    handleClickOutside(e){
      if(!e.target.closest('.tag-search-area')){
        this.showTagDropdown = false;
      }
      if(!e.target.closest('.stats-tag-search-area')){
        this.showStatsTagDropdown = false;
      }
    },
    // --- 消費統計查詢 ---
    onStatsTagSearch(){
      if(this.statsTagSearchQuery.length === 0){
        this.statsFilteredTags = [];
        return;
      }
      const query = this.statsTagSearchQuery.toLowerCase();
      this.statsFilteredTags = this.allTags.filter(tag =>
        tag.toLowerCase().includes(query)
      ).slice(0, 50);
      this.showStatsTagDropdown = true;
    },
    selectStatsTag(tag){
      this.statsSelectedTag = tag;
      this.showStatsTagDropdown = false;
      this.statsTagSearchQuery = '';
      this.statsFilteredTags = [];
      this.queryTagStats(tag);
    },
    clearStatsTag(){
      this.statsSelectedTag = null;
      this.statsData = { avgCount: null, avgTotalAmount: null, memberCount: null };
      this.statsDisplay = { avgCount: 0, avgTotalAmount: 0, memberCount: 0 };
      this.statsLoaded = false;
    },
    animateStats(){
      const duration = 800;
      const start = performance.now();
      const targets = {
        avgCount: this.statsData.avgCount,
        avgTotalAmount: this.statsData.avgTotalAmount,
        memberCount: this.statsData.memberCount
      };
      this.statsDisplay = { avgCount: 0, avgTotalAmount: 0, memberCount: 0 };
      const step = (now) => {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        // easeOutCubic
        const ease = 1 - Math.pow(1 - progress, 3);
        this.statsDisplay.avgCount = parseFloat((targets.avgCount * ease).toFixed(2));
        this.statsDisplay.avgTotalAmount = Math.round(targets.avgTotalAmount * ease);
        this.statsDisplay.memberCount = Math.round(targets.memberCount * ease);
        if(progress < 1){
          requestAnimationFrame(step);
        } else {
          this.statsDisplay.avgCount = targets.avgCount;
          this.statsDisplay.avgTotalAmount = targets.avgTotalAmount;
          this.statsDisplay.memberCount = targets.memberCount;
        }
      };
      requestAnimationFrame(step);
    },
    onStatsMainCategoryChange(){
      this.statsSelectedSubCategory = null;
      this.statsLoaded = false;
      this.statsData = { avgCount: null, avgTotalAmount: null, memberCount: null };
      this.statsDisplay = { avgCount: 0, avgTotalAmount: 0, memberCount: 0 };
      const mainCat = this.allCategories.find(c => c.main_type === this.statsSelectedMainCategory);
      if(mainCat && mainCat.sub_types){
        this.statsSubCategoryOptions = mainCat.sub_types;
      } else {
        this.statsSubCategoryOptions = [];
      }
    },
    onStatsSubCategoryChange(){
      if(!this.statsSelectedSubCategory) return;
      const subCat = this.statsSubCategoryOptions.find(s => s.sub_type === this.statsSelectedSubCategory);
      if(subCat){
        this.querySubTypeStats(subCat.ProductSubTypeName);
      }
    },
    queryTagStats(tag){
      this.statsLoading = true;
      this.statsLoaded = false;
      axios
        .get('https://dashbk.ecpaydata.com.tw/api/api.php?act=query_tag_avg&tag=' + encodeURIComponent(tag))
        .then((response) => {
          if(response.data && response.data.code === 200){
            this.statsData.avgCount = response.data.data[0].avg_count;
            this.statsData.avgTotalAmount = Math.round(response.data.data[0].avg_total_amount);
            this.statsData.memberCount = response.data.data_count[0].MemberCount;
            this.statsLoaded = true;
            this.animateStats();
          }
        })
        .catch((error) => {
          console.error('Failed to query tag stats:', error);
        })
        .finally(() => {
          this.statsLoading = false;
        });
    },
    querySubTypeStats(subType){
      this.statsLoading = true;
      this.statsLoaded = false;
      axios
        .get('https://dashbk.ecpaydata.com.tw/api/api.php?act=query_ProductSubType_avg_and_customers_count&sub_type=' + encodeURIComponent(subType))
        .then((response) => {
          if(response.data && response.data.code === 200){
            this.statsData.avgCount = response.data.data[0].avg_count;
            this.statsData.avgTotalAmount = Math.round(response.data.data[0].avg_total_amount);
            this.statsData.memberCount = response.data.payment_count[0].MemberCount;
            this.statsLoaded = true;
            this.animateStats();
          }
        })
        .catch((error) => {
          console.error('Failed to query sub type stats:', error);
        })
        .finally(() => {
          this.statsLoading = false;
        });
    },
    loadCategories(){
      axios
        .get('https://dashbk.ecpaydata.com.tw/api/api.php?act=get_all_main_sub_type')
        .then((response) => {
          if(response.data && response.data.data){
            this.allCategories = response.data.data;
            console.log('Categories loaded:', this.allCategories.length);
          }
        })
        .catch((error) => {
          console.error('Failed to load categories:', error);
        });
    },
    onMainCategoryChange(){
      this.selectedSubCategory = null;
      this.audienceQueried = false;
      const mainCat = this.allCategories.find(c => c.main_type === this.selectedMainCategory);
      if(mainCat && mainCat.sub_types){
        this.subCategoryOptions = mainCat.sub_types;
      } else {
        this.subCategoryOptions = [];
      }
    },
    queryAudienceCount(){
      this.audienceQuerying = true;
      this.audienceQueried = false;

      let url = 'https://dashbk.ecpaydata.com.tw/api/api.php?act=autoturn_query_audience';

      if(this.audienceMode === 'tag'){
        const tagsParam = this.selectedTags.join(',');
        url += '&tags=' + encodeURIComponent(tagsParam);
      } else if(this.audienceMode === 'category'){
        // 取得次分類名稱
        const subCat = this.subCategoryOptions.find(s => s.sub_type === this.selectedSubCategory);
        if(subCat){
          url += '&sub_type=' + encodeURIComponent(subCat.ProductSubTypeName);
        }
      }

      axios
        .get(url)
        .then((response) => {
          if(response.data && response.data.code === 200){
            this.audienceSize = response.data.data.audience_size;
            this.audienceQueried = true;

            if(this.audienceSize > 50000){
              Swal.fire({
                icon: 'warning',
                title: '受眾筆數超過上限',
                text: '查詢結果共 ' + this.audienceSize.toLocaleString() + ' 筆，超過 50,000 筆上限。建立受眾時僅會上傳前 50,000 筆資料。',
                confirmButtonText: '了解'
              });
            }
          } else {
            Swal.fire('查詢失敗', '無法取得受眾資料，請稍後再試。', 'error');
          }
        })
        .catch((error) => {
          console.error('Failed to query audience:', error);
          Swal.fire('查詢失敗', '連線錯誤，請稍後再試。', 'error');
        })
        .finally(() => {
          this.audienceQuerying = false;
        });
    },
    createAudience(){
      if(this.audienceName.trim() === ''){
        Swal.fire('提示', '請輸入受眾名稱', 'warning');
        return;
      }
      if(!this.accountSelect || this.accountSelect === ''){
        Swal.fire('提示', '請先選擇廣告帳戶', 'warning');
        return;
      }

      // Plan 142 額度檢查
      if(this.isPlan142){
        const effectiveCount = Math.min(this.audienceSize, 50000);
        if(effectiveCount > this.audienceQuota.remaining){
          Swal.fire({
            icon: 'error',
            title: '受眾額度不足',
            html: '本次建立需要 <b>' + effectiveCount.toLocaleString() + '</b> 筆額度，' +
                  '但本月剩餘額度僅 <b>' + this.audienceQuota.remaining.toLocaleString() + '</b> 筆。',
            confirmButtonText: '了解'
          });
          return;
        }
      }

      this.audienceCreating = true;

      let params = {
        act: 'autoturn_create_audience',
        account_id: this.accountSelect.replace('act_', ''),
        audienceNames: this.audienceName.trim(),
        uid: this.memberId,
      };

      if(this.audienceMode === 'tag'){
        params.tags = this.selectedTags.join(',');
      } else if(this.audienceMode === 'category'){
        const subCat = this.subCategoryOptions.find(s => s.sub_type === this.selectedSubCategory);
        if(subCat){
          params.sub_type = subCat.ProductSubTypeName;
        }
      }

      axios
        .post('https://dashbk.ecpaydata.com.tw/api/api.php', Qs.stringify(params))
        .then((response) => {
          if(response.data && response.data.code === 200){
            Swal.fire({
              icon: 'success',
              title: '建立成功',
              text: '受眾「' + this.audienceName + '」已建立成功！',
              confirmButtonText: '確定'
            });
            // Plan 142: 記錄用量（在清空名稱前呼叫）
            if(this.isPlan142){
              this.recordAudienceUsage();
            }
            this.audienceName = '';
          } else {
            let errMsg = (response.data && response.data.data && response.data.data.message) ? response.data.data.message : '建立受眾失敗，請稍後再試。';
            Swal.fire('建立失敗', errMsg, 'error');
          }
        })
        .catch((error) => {
          console.error('Failed to create audience:', error);
          Swal.fire('建立失敗', '連線錯誤，請稍後再試。', 'error');
        })
        .finally(() => {
          this.audienceCreating = false;
        });
    }
  }
}
</script>

<style scoped>
/* ─── PAGE LAYOUT ─── */
.audience-page {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.audience-main {
  flex: 1;
  overflow-y: auto;
  background: var(--ice, #f0f5fc);
}

.audience-content {
  max-width: 1280px;
  width: 92%;
  margin: 0 auto;
  padding: 32px 0;
}

/* ─── HEADER TOOLBAR SLOT ─── */
.aud-toolbar-label {
  margin: 0 12px;
  font-size: 13px;
  color: var(--slate, #64748b);
  font-weight: 500;
  white-space: nowrap;
}

.aud-toolbar-dropdown {
  margin: 0 4px;
}

.aud-quota {
  margin-left: 16px;
  padding-left: 16px;
  border-left: 1px solid rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  gap: 8px;
}

.aud-quota-icon {
  color: var(--d2-blue, #2563eb);
  font-size: 14px;
}

.aud-quota-label {
  font-size: 13px;
  color: var(--slate, #64748b);
  white-space: nowrap;
}

.aud-quota-value {
  font-size: 13px;
  font-weight: 700;
}

.aud-quota-value--ok {
  color: var(--d2-blue, #2563eb);
}

.aud-quota-value--danger {
  color: var(--d2-red, #ef4444);
}

.aud-quota-total {
  font-size: 13px;
  color: var(--slate, #64748b);
}

/* ─── MODE TABS ─── */
.mode-tabs {
  display: flex;
  gap: 0;
  margin-bottom: 24px;
}

.mode-tab {
  padding: 10px 26px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  border: 2px solid rgba(0, 0, 0, 0.08);
  background: var(--d2-white, #fff);
  color: var(--slate, #64748b);
  transition: all 0.2s;
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: inherit;
}

.mode-tab:first-child {
  border-radius: 12px 0 0 12px;
}

.mode-tab:last-child {
  border-radius: 0 12px 12px 0;
  border-left: none;
}

.mode-tab.active {
  background: var(--d2-blue, #2563eb);
  color: #fff;
  border-color: var(--d2-blue, #2563eb);
}

.mode-tab:not(.active):hover {
  background: var(--sky-light, #eff6ff);
  border-color: var(--d2-blue-light, #60a5fa);
}

.mode-tab i {
  font-size: 14px;
}

/* ─── CARD ─── */
.aud-card {
  background: var(--d2-white, #fff);
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(15, 43, 74, 0.08);
  padding: 28px;
  margin-bottom: 24px;
}

.aud-card-title {
  font-family: 'DM Serif Display', serif;
  font-size: 20px;
  color: var(--navy, #0f2b4a);
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.aud-card-title > i:first-child {
  color: var(--d2-blue, #2563eb);
  font-size: 18px;
}

.aud-help-icon {
  color: var(--slate, #64748b);
  opacity: 0.5;
  font-size: 14px !important;
  cursor: help;
  margin-left: 4px;
}

/* ─── TWO COLUMN ─── */
.two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 20px;
}

.col-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--navy, #0f2b4a);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.col-label i {
  color: var(--d2-blue, #2563eb);
  font-size: 13px;
}

.col-label-count {
  color: var(--d2-blue, #2563eb);
  font-weight: 500;
}

/* ─── SEARCH AREA (position context for autocomplete) ─── */
.tag-search-area,
.stats-tag-search-area {
  position: relative;
}

/* ─── SEARCH INPUT ─── */
.search-wrap {
  position: relative;
  margin-bottom: 4px;
}

.search-input {
  width: 100%;
  padding: 12px 16px 12px 42px;
  border-radius: 12px;
  border: 1.5px solid rgba(0, 0, 0, 0.1);
  font-size: 14px;
  font-family: inherit;
  color: var(--charcoal, #1e293b);
  background: var(--d2-white, #fff);
  transition: all 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: var(--d2-blue, #2563eb);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.search-input::placeholder {
  color: #b0bec5;
}

.search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--slate, #64748b);
  font-size: 14px;
}

/* ─── AUTOCOMPLETE ─── */
.autocomplete {
  background: var(--d2-white, #fff);
  border: 1.5px solid rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(15, 43, 74, 0.12);
  margin-top: 6px;
  margin-bottom: 20px;
  overflow: hidden;
  max-height: 240px;
  overflow-y: auto;
  position: absolute;
  z-index: 10;
  width: 100%;
}

.autocomplete-item {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.15s;
}

.autocomplete-item:hover {
  background: var(--sky-light, #eff6ff);
}

.autocomplete-item.active {
  background: var(--sky-light, #eff6ff);
  color: var(--d2-blue, #2563eb);
}

.autocomplete-item + .autocomplete-item {
  border-top: 1px solid rgba(0, 0, 0, 0.04);
}

.autocomplete-check {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  border: 2px solid rgba(0, 0, 0, 0.12);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: transparent;
  flex-shrink: 0;
  transition: all 0.15s;
}

.autocomplete-check.checked {
  background: var(--d2-blue, #2563eb);
  border-color: var(--d2-blue, #2563eb);
  color: #fff;
}

.autocomplete-tag-name {
  flex: 1;
  font-weight: 500;
}

.autocomplete-empty {
  padding: 12px 16px;
  font-size: 14px;
  color: var(--slate, #64748b);
  text-align: center;
}

/* ─── STATS ROW ─── */
.stat-row {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-top: 16px;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: var(--sky-light, #eff6ff);
  border-radius: 14px;
  border: 1px solid rgba(37, 99, 235, 0.06);
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  flex-shrink: 0;
}

.stat-icon.blue {
  background: linear-gradient(135deg, var(--d2-blue, #2563eb), var(--d2-blue-light, #60a5fa));
}

.stat-icon.green {
  background: linear-gradient(135deg, #22c55e, #4ade80);
}

.stat-icon.purple {
  background: linear-gradient(135deg, #8b5cf6, #a78bfa);
}

.stat-icon-dollar {
  font-size: 22px;
  font-weight: 700;
}

.stat-label {
  font-size: 13px;
  color: var(--slate, #64748b);
  margin-bottom: 4px;
}

.stat-value {
  font-size: 24px;
  font-weight: 700;
  color: var(--navy, #0f2b4a);
  font-family: 'DM Serif Display', serif;
}

.aud-loading {
  margin-top: 16px;
  text-align: center;
  color: var(--slate, #64748b);
  padding: 16px 0;
  font-size: 14px;
}

.aud-loading i {
  margin-right: 8px;
}

/* ─── SELECTED AREA ─── */
.selected-area {
  min-height: 120px;
  background: var(--sky-light, #eff6ff);
  border-radius: 12px;
  border: 1.5px dashed rgba(37, 99, 235, 0.2);
  padding: 16px;
}

.selected-area--centered {
  display: flex;
  align-items: center;
  justify-content: center;
}

.selected-empty {
  font-size: 14px;
  color: var(--slate, #64748b);
}

.selected-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.selected-count {
  font-size: 12px;
  color: var(--slate, #64748b);
}

.clear-all {
  font-size: 12px;
  color: #ef4444;
  cursor: pointer;
  text-decoration: none;
  font-weight: 500;
}

.clear-all:hover {
  text-decoration: underline;
}

.selected-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  background: var(--d2-blue, #2563eb);
  color: #fff;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
}

.tag-pill-x {
  cursor: pointer;
  opacity: 0.7;
  font-size: 11px;
  transition: opacity 0.15s;
  background: none;
  border: none;
  color: inherit;
  padding: 0;
}

.tag-pill-x:hover {
  opacity: 1;
}

/* ─── QUERY ROW ─── */
.query-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}

.result-display {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
}

.result-value {
  font-size: 18px;
  font-weight: 700;
}

.result-value.orange {
  color: #f59e0b;
}

.result-value.green {
  color: #22c55e;
}

/* ─── WARNING BOX ─── */
.warning-box {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 14px 18px;
  background: #fffbeb;
  border: 1.5px solid #fcd34d;
  border-radius: 12px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #92400e;
  line-height: 1.6;
}

.warning-box i {
  color: #f59e0b;
  margin-top: 2px;
  flex-shrink: 0;
  font-size: 15px;
}

.warning-box--danger {
  background: #fef2f2;
  border-color: #fca5a5;
  color: #991b1b;
}

.warning-box--danger i {
  color: #ef4444;
}

/* ─── NAME INPUT ─── */
.name-input {
  width: 100%;
  padding: 12px 16px;
  border-radius: 12px;
  border: 1.5px solid rgba(0, 0, 0, 0.1);
  font-size: 14px;
  font-family: inherit;
  color: var(--charcoal, #1e293b);
  transition: border-color 0.2s;
}

.name-input:focus {
  outline: none;
  border-color: var(--d2-blue, #2563eb);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.name-input::placeholder {
  color: #b0bec5;
}

/* ─── CREATE SECTION ─── */
.aud-create-section {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.aud-create-row {
  display: flex;
  align-items: flex-end;
  gap: 16px;
}

.aud-create-input-wrap {
  flex: 1;
}

/* ─── BUTTONS ─── */
.btn {
  padding: 10px 24px;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: inherit;
  white-space: nowrap;
}

.btn:disabled {
  background: #d1d5db;
  cursor: not-allowed;
  color: #9ca3af;
  border-color: #d1d5db;
}

.btn-primary {
  background: var(--d2-blue, #2563eb);
  color: #fff;
}

.btn-primary:not(:disabled):hover {
  background: var(--navy, #0f2b4a);
}

.btn-outline {
  background: transparent;
  border: 2px solid var(--d2-blue, #2563eb);
  color: var(--d2-blue, #2563eb);
}

.btn-outline:not(:disabled):hover {
  background: var(--sky, #dbeafe);
}

.btn-sm {
  padding: 8px 18px;
  font-size: 13px;
  border-radius: 8px;
}

/* ─── RESPONSIVE ─── */
@media (max-width: 768px) {
  .audience-content {
    padding: 16px 0;
    width: 95%;
  }

  .stat-row {
    grid-template-columns: 1fr !important;
    gap: 10px;
  }

  .two-col {
    grid-template-columns: 1fr !important;
  }

  .aud-card {
    padding: 20px;
  }

  .aud-create-row {
    flex-direction: column;
    align-items: stretch;
  }

  /* aud-quota / aud-toolbar-label / aud-toolbar-dropdown 的手機隱藏 & 寬度限制
     已移除 — 改由 Header toolbar panel (CSS Grid) 統一處理排版 */
}

@media (max-width: 480px) {
  .mode-tabs {
    flex-direction: column;
  }

  .mode-tab:first-child {
    border-radius: 12px 12px 0 0;
  }

  .mode-tab:last-child {
    border-radius: 0 0 12px 12px;
    border-left: 2px solid rgba(0, 0, 0, 0.08);
    border-top: none;
  }

  .aud-toolbar-dropdown :deep(.p-dropdown) {
    max-width: 120px;
    min-width: 90px;
    font-size: 12px;
  }

  .aud-card {
    padding: 16px;
    border-radius: 14px;
  }

  .aud-card-title {
    font-size: 17px;
  }

  .stat-card {
    padding: 14px;
  }

  .stat-value {
    font-size: 20px;
  }
}
</style>
